<template>
  <div>
    <v-container
        fluid
        style="height: 100%"
    >
      <v-row
          align="center"
          justify="center"
      >
        <v-col
            cols="12"
            md="4"
            sm="8"
        >
          <v-card style="margin-top: 80px;" class="elevation-12">
            <v-toolbar
                color="info"
                dark
                flat
            >
              <v-toolbar-title >
                Tizimga kirish
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                    v-model="payload.username"
                    label="User name"
                    name="username"
                    prepend-icon="mdi-account"
                    type="text"
                ></v-text-field>

                <v-text-field
                    v-model="payload.password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                ></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="login()" color="info">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar v-model="snackbar"  color="red" outlined right>
      Login yoki parolda xatolik bor!
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: "Login",
  data: () => ({
    snackbar: false,
    payload: {
      username: '',
      password: "",
    },
    jwt: '',
    eye: false,
  }),
  methods: {
    login() {
      axios.post('https://demo.andqxai.uz/api/auth/signin', this.payload).then(res => {
        this.jwt = res.data.accessToken
        localStorage.removeItem('jwt')
        localStorage.setItem('jwt', this.jwt)
        this.$store.dispatch('setJwt', this.jwt)
        this.$router.push('/book')
      }).catch(() => {
        this.snackbar = true
      })
    }
  },
}
</script>

<style scoped>

</style>
